<ng-template #bodyContainer></ng-template>
<div #fakeScroll class="fakeScroll" *ngIf="vertscrollbar"></div>
<!-- <div #fakeScrollHorz class="fakeScrollhorz" *ngIf="horzscrollbar"></div> -->
<!-- <div style="height: 30000px; width: 1px;"></div> -->
